import { SvgIcon } from '@mui/material'
import React from 'react'

export const UsersIcon = ({sx,...props}) => {
    return (
        <SvgIcon {...{ sx: sx?.color ? { ...sx, stroke: sx.color, color: '#fff' } : sx, ...props }}>
            <path d="M13 20V18C13 15.2386 10.7614 13 8 13C5.23858 13 3 15.2386 3 18V20H13ZM13 20H21V19C21 16.0545 18.7614 14 16 14C14.5867 14 13.3103 14.6255 12.4009 15.6311M11 7C11 8.65685 9.65685 10 8 10C6.34315 10 5 8.65685 5 7C5 5.34315 6.34315 4 8 4C9.65685 4 11 5.34315 11 7ZM18 9C18 10.1046 17.1046 11 16 11C14.8954 11 14 10.1046 14 9C14 7.89543 14.8954 7 16 7C17.1046 7 18 7.89543 18 9Z"  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </SvgIcon>
    )
}
